<section class="breadcrumbs-component">
  <!-- breadcrumb list data -->
  @for (data of breadcrumbsData(); track data.id; let i = $index) {
    <!-- link for each breadcrumb item -->
    <a
      [routerLink]="data?.breadCrumbUrl"
      [queryParams]="data?.breadCrumbParams || {}"
      class="breadcrumbs-component__content"
      [ngClass]="{ 'pointer-events-none': !data?.breadCrumbUrl }">
      <!-- title for each breadcrumb item -->
      <p
        class="breadcrumbs-component__title"
        [ngClass]="{
          'text-gray-600': i < breadcrumbsData().length - 1,
          'text-primary-dark': i === breadcrumbsData().length - 1,
        }">
        {{ data.breadCrumbTitle | translate }}
      </p>

      @if (i < breadcrumbsData().length - 1) {
        <i
          class="iconsax breadcrumbs-component__icon"
          icon-name="chevron-right">
        </i>
      }
    </a>
  }
</section>
